import React from 'react';
import { TConnector, TField, TIndexState, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput , TTransformation} from '../model';
import TransformationComponent from '../../../Components/TransformationComponent';
import TransformationRulesComponent from '../../../Components/Rules/TransformationRuleComponent';

type TTransformationDetails = {
    id: string;
    subSelectedItem: TTransformation|null
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null ;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
    indexInfo: TIndexState;
    createISRProject:()=>void
}

const TransformationField = ({id, subSelectedItem, selectedItem, userProjectDataModels, setUserProjectDataModels, indexInfo, createISRProject}: TTransformationDetails) => {
    return (
        <div id={id}>
            <TransformationComponent 
                id={`${id}-transformation`}
                selectedItem={selectedItem} 
                userProjectDataModels={userProjectDataModels} 
                setUserProjectDataModels={setUserProjectDataModels} 
                indexInfo={indexInfo} 
                subSelectedItem={subSelectedItem}  
                createISRProject={createISRProject}
            />
            <TransformationRulesComponent 
                id={`${id}-transformation-rules`}
                selectedItem={selectedItem} 
                userProjectDataModels={userProjectDataModels} 
                setUserProjectDataModels={setUserProjectDataModels} 
                indexInfo={indexInfo} 
                subSelectedItem={subSelectedItem} 
                createISRProject={createISRProject}
            />
        </div>
    );
}

export default TransformationField;